<template>
<div class="similar-projects">
       <ul>
        <ProjectItem v-for="proj in projects" :key="proj.id" :proj="proj"/>
       </ul>
</div>
</template>
<script setup lang='ts'>
import ProjectItem from '../projets/ProjectItem.vue';


/*  IMPORTS  */

/*  VARIABLES  */

const {category,projId} = defineProps<{
    category:number | null,
    projId:number
}>()
const {getProjectsByCategory} = useWordpressApi()

const { data: projects } = await useAsyncData(
  `similar-${category}`,
  () => category ? getProjectsByCategory(category,projId) : Promise.resolve([])
)
/*  FUNCTIONS  */
</script>

<style lang="scss">
    .similar-projects{
        text-align: center;
        ul{
            list-style-type: none;
            display: flex;
            align-items: center;
            gap:1rem;
            flex-wrap: wrap;
            .project-item{
                @media screen and (max-width:1035px) {
                   flex: auto;
                   width: 200px;
                   height: 200px;
                }
            }
            .project-legend{
                p{
                    color: $white;
                }
            }
            
        }
    }
</style>